import QueryBuilder from '@mui/icons-material/QueryBuilder';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function QueryBuilderIcon(props: FixMe) {
  return <QueryBuilder {...props} />;
}

export default QueryBuilderIcon;
